import {Helmet} from '@dr.pogodin/react-helmet';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetTenantQuery} from '@dms/api/core';
import {
  useAccGetMatrix202and205Query,
  useGetAccountingContextCodeTableIdQuery,
} from '@dms/api/finance';
import {useGetAuthorizationProfileQuery} from '@dms/api/security';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {useRequiredParams} from 'shared/web';

import {AccountingCodesDetailForm} from './components/AccountingCodesDetailForm';

export function AccountingCodesDetail() {
  const {id} = useRequiredParams();

  const {data: tenant, isLoading: isTenantLoading, isError: hasTenantError} = useGetTenantQuery();

  const {
    data: accountingCodeDetail,
    isLoading: isAccountingCodeDetailLoading,
    isError: isAccountingCodeDetailError,
  } = useGetAccountingContextCodeTableIdQuery({
    referenceId: id,
  });

  const {
    data: accountingCodes,
    isLoading: isAccountingCodesLoading,
    isError: isAccountingCodesError,
  } = useAccGetMatrix202and205Query({orderVariantPart: 'case-type'});

  const {
    data: authorizationProfile,
    isLoading: isAuthorizationProfileLoading,
    isError: isAuthorizationProfileError,
  } = useGetAuthorizationProfileQuery(
    {
      authorizationProfileId: id,
      'x-tenant': tenant?.id as string,
    },
    {
      skip: isNilOrEmpty(tenant),
    }
  );

  const title = authorizationProfile?.name ?? i18n.t('entity.settings.labels.accountingCode');
  const isLoading =
    isAccountingCodeDetailLoading ||
    isAuthorizationProfileLoading ||
    isTenantLoading ||
    isAccountingCodesLoading;
  const isError =
    isAccountingCodeDetailError ||
    isAuthorizationProfileError ||
    hasTenantError ||
    isAccountingCodesError ||
    (!isAccountingCodesLoading && isNil(accountingCodes));

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{title}}
        data-testid="accounting-codes-detail-settings-header"
        isLoading={isLoading}
        isError={isError}
      >
        <AccountingCodesDetailForm
          accountingCodeDetail={accountingCodeDetail!}
          authorizationProfile={authorizationProfile!}
          codes={accountingCodes ?? null}
        />
      </SettingsTemplate>
    </>
  );
}
